import React from 'react';
import { useDispatch } from 'react-redux';

import { AddressManuallyFields } from './components/AddressManuallyFields';
import { AddressPostCodeFields } from './components/AddressPostCodeFields';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { setIsManuallyAddress } from '@interlayer/js/app/store/reducers/Registration/actions';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TAddressFieldsProps } from './types';

export const AddressFields: React.FC<TAddressFieldsProps> = ({
    isShowLinkAuto,
    isNearestClub = true,
    isClubSelectForced = false
}) => {
    const dispatch = useDispatch();
    const { isManuallyAddress } = useRegistrationSelector();

    const handlerSwitchManually = (isManually: boolean) => {
        dispatch(setIsManuallyAddress(isManually));
    };

    return (
        <>
            <AddressPostCodeFields
                isNearestClub={isNearestClub}
                isClubSelectForced={isClubSelectForced}
                handlerSwitchManually={handlerSwitchManually}
                className={clsx({ hidden: isManuallyAddress })}
            />

            <AddressManuallyFields
                isSeparateRows
                isShowLinkAuto={isShowLinkAuto}
                handlerSwitchManually={handlerSwitchManually}
                className={clsx({ hidden: !isManuallyAddress })}
            />
        </>
    );
};
